import { Component, EventEmitter, Input, Output } from '@angular/core';

type messageType = 'error' | 'warning_amber' | 'warning' | 'info' | 'check';

@Component({
  selector: 'aodocs-message-banner',
  templateUrl: './message-banner.component.html',
  styleUrls: ['./message-banner.component.scss'],
})
export class MessageBannerComponent {
  @Input() message: string | undefined;
  @Input() displayCloseButton = true;
  @Input() type: messageType = 'error';
  @Output() closed = new EventEmitter();
}
